import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { useIntl } from 'react-intl';

const NotificationTextShare = ({ share }) => {
  const intl = useIntl();

  return (
    <>
      {share ? (
        <Link to={`/shares/${share.uuid}`} target="_blank">
          <strong>{intl.formatMessage({ defaultMessage: 'a link you shared' })}</strong>
        </Link>
      ) : (
        intl.formatMessage({ defaultMessage: 'a link you shared' })
      )}
    </>
  );
};

NotificationTextShare.propTypes = {
  share: PropTypes.object,
};

NotificationTextShare.defaultProps = {
  share: null,
};

export default NotificationTextShare;
